












































import { Component, Prop, Emit, Ref } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { ModalFooter } from '@/components/molecules/ModalFooter'
import { Col, DataTable } from '@/components/molecules/DataTable'
import { Alert } from '@/api'
import { AtomButton } from '@/components/atoms'

@Component({
  components: {
    DataTable,
    ModalFooter
  }
})
export default class ModalForwardingRequestConfirm extends ComponentVue {
  @Ref()
  forwardingRequestAtomButton!: AtomButton

  @Prop({
    type: Array,
    required: true
  })
  alerts!: Alert[]

  dialog: boolean = false

  cols: Col[] = [
    {
      width: 50,
      items: [
        {
          name: 'no',
          align: 'right'
        }
      ]
    },
    {
      width: '20',
      resizable: true,
      movable: true,
      items: [
        {
          name: 'code',
          headerText: 'コード'
        }
      ]
    },
    {
      width: '80',
      resizable: true,
      movable: true,
      items: [
        {
          name: 'message',
          headerText: 'メッセージ',
          lineFeed: true
        }
      ]
    }
  ]

  open(): void {
    this.dialog = true
    setTimeout(() => {
      this.forwardingRequestAtomButton.atomButton.$el.focus()
    })
  }

  close(): void {
    this.dialog = false
  }

  print() {
    const element = document.querySelector('#modal-forwarding-request-confirm')

    if (element) {
      this.$webSocket.sendDialogScreenshotMessage(element)
    } else {
      this.$webSocket.sendScreenshotMessage()
    }
  }

  @Emit('forwarding-request')
  onClickForwardingRequest(): void {
    this.close()
  }

  @Emit('reserve')
  onClickReserve(): void {
    this.close()
  }

  onClickCancel(): void {
    this.close()
  }
}
